import { CaseNoticeType } from '@/@types/generated'
import { register } from './enum'

export const CaseNoticeTypeLabels: Record<CaseNoticeType, string> = {
  [CaseNoticeType.AV_NOTICE_OF_INTENT]: 'Notice of Intent',
  [CaseNoticeType.AV_NOTICE_OF_DEPARTMENT_DECISION]:
    'Notice of Department Decision',
  [CaseNoticeType.AV_FINAL_DETERMINATION]: 'Final Determination',
  [CaseNoticeType.NOTICE_OF_HEARING]: 'Notice of Hearing',
  [CaseNoticeType.MC_NOTICE_OF_DEPARTMENT_DECISION]:
    'Notice of Department Decision',
  [CaseNoticeType.MC_LETTER_OF_WARNING]: 'Letter of Warning',
  [CaseNoticeType.MC_FINAL_ORDER]: 'Final Order',
  [CaseNoticeType.MC_AGREED_FINAL_ORDER]: 'Agreed Final Order',
  [CaseNoticeType.MC_DPS_UNSAT_CLOSURE_LETTER]: 'DPS Unsat Closure Letter',
  [CaseNoticeType.FIRST_DEMAND_LETTER]: 'First Demand Letter',
  [CaseNoticeType.FINAL_DEMAND_LETTER]: 'Final Demand Letter',
}

export const CaseNoticeTypeAbbr: Record<CaseNoticeType, string> = {
  [CaseNoticeType.AV_NOTICE_OF_INTENT]: 'AV-NOI',
  [CaseNoticeType.AV_NOTICE_OF_DEPARTMENT_DECISION]: 'AV-NODD',
  [CaseNoticeType.AV_FINAL_DETERMINATION]: 'AV-FD',
  [CaseNoticeType.NOTICE_OF_HEARING]: 'NOH',
  [CaseNoticeType.MC_NOTICE_OF_DEPARTMENT_DECISION]: 'MC-NODD',
  [CaseNoticeType.MC_LETTER_OF_WARNING]: 'MC-LOW',
  [CaseNoticeType.MC_FINAL_ORDER]: 'MC-FO',
  [CaseNoticeType.MC_AGREED_FINAL_ORDER]: 'MC-AFO',
  [CaseNoticeType.MC_DPS_UNSAT_CLOSURE_LETTER]: 'MC-CL',
  [CaseNoticeType.FIRST_DEMAND_LETTER]: '1DL',
  [CaseNoticeType.FINAL_DEMAND_LETTER]: 'FDL',
}

register<CaseNoticeType>(CaseNoticeType, (v) => {
  if (!v) return '\u2014'
  return `${CaseNoticeTypeLabels[v]} (${CaseNoticeTypeAbbr[v]})`
})
